import axios from 'axios'

const settings = {
  namespaced: true,
  state: {
    TERYT: undefined
  },
  mutations: {
    setSettings (state, newValue) {
      state.TERYT = newValue.TERYT
    }
  },
  actions: {
    loadSettings (context, filePath) {
      axios.get(filePath)
        .then((response) => {
          context.commit('setSettings', response.data)
        }, (error) => {
          console.error(error)
        })
    }
  }
}

export default settings
